import { useFocusEffect } from 'expo-router'
import { useCallback } from 'react'

import { useSyncedRef } from './useSyncedRef'

export const useInterval = (
  /** If null, the interval will carry on without calling anything */
  callback: VoidFunction | null,
  /** If null, useInterval will be disabled. Note: 0 is a valid value for delay */
  delay: number | null,
) => {
  const syncedCallbackRef = useSyncedRef(callback)
  const focusCallback = useCallback(() => {
    if (delay === null) {
      return
    }

    const interval = setInterval(() => {
      syncedCallbackRef.current?.()
    }, delay)

    return () => clearInterval(interval)
  }, [delay, syncedCallbackRef])

  useFocusEffect(focusCallback)
}
